module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAuBAMAAACytabNAAAAFVBMVEUAAAAgyPIgyPIgyPIgyPIgyPIgyPIc+LnVAAAABnRSTlMA8a0nKCWPqJUsAAAASUlEQVQoz2NgVRQKYIABCM8wLU0YLgLhqaWlJcFFIDyxtLREuAiElwYEcBEwb1RoVGgoC2EmcmxZwTEtTQQuAuExKwoZwEXAPABja4m7LZr2XwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pause_share.png
// module id = 486
// module chunks = 0